import axios, { AxiosError } from 'axios';
import { ApiV4Error } from '@/Services/BKAPI/Errors/ApiV4Error';
import { CanceledRequestError } from '@/Services/BKAPI/Errors/CanceledRequestError';
import { ClientNetworkError } from '@/Services/BKAPI/Errors/ClientNetworkError';
import { InvalidRequestError } from '@/Services/BKAPI/Errors/InvalidRequestError';

type AxiosV4ErrorResponse = AxiosError<{
    status: number;
    error_code: string;
    error_message: string;
    error_details: string[];
}>;

const isApiV4Error = (error: AxiosError): error is AxiosV4ErrorResponse => {
    const data = error.response?.data as any;
    return data?.error_code && data?.error_message && data?.error_details;
};
const handleAxiosError = (error: AxiosError): Error => {
    if (error?.code === 'ERR_NETWORK') {
        return new ClientNetworkError(error?.message);
    }
    if (isApiV4Error(error)) {
        return new ApiV4Error({
            status: error.response?.data?.status as number,
            error_details: error.response?.data.error_details as string[],
            error_message: error.response?.data?.error_message as string,
            error_code: error.response?.data?.error_code as string,
        });
    }

    if (
        error.response?.status &&
        error.response.status >= 400 &&
        error.response.status < 500
    ) {
        return InvalidRequestError.fromFourHundrishCode(
            error.response.status,
            error.message
        );
    }

    return error;
};
export const fromGenericError = (error: unknown): Error => {
    // Checked before the AxiosError narrowing below: axios types `Cancel` as
    // `{ message: string | undefined }`, which AxiosError is assignable to, so
    // an `isCancel` guard inside handleAxiosError narrows its else-branch to `never`.
    if (axios.isCancel(error)) {
        return CanceledRequestError.fromCanceledRequest();
    }
    if (axios.isAxiosError(error)) {
        return handleAxiosError(error);
    }
    return error instanceof Error ? error : new Error(String(error));
};
